<template>
  <div id="primary-nav">  
    <b-nav v-b-scrollspy>
      <div class="p-nav-links">
        
        <!-- <b-nav-item
          class="p-nav-link"
          href="#Landing"
          v-scroll-to="'#Landing'"
        >
          Home
        </b-nav-item>
        <b-nav-item
          class="p-nav-link" 
          href="#Form"
          v-scroll-to="'#Form'"
        >
          Select Your Prizes
        </b-nav-item> -->
        <b-nav-item
          class="p-nav-link"
        >
          <b-button v-b-modal.modal-rules>Sweepstakes Rules</b-button>
        </b-nav-item>
      </div>
    </b-nav>
  </div>
</template>

<script>
export default {
  name: "PrimaryNav"
};
</script>

<style lang="scss" scoped>
#primary-nav {
  height: 77px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  @media(max-width: $xl){
    padding-right: 6.2vw;
  }
  /**Adjust this padding for mobile, remove and justify center */
  .p-nav-links {
    display: flex;
    height: 100%;
    flex-direction: row;
    background: transparent;
    margin-right: -45px;
    @media(max-width: $xl){
      margin-right: -105px;
    }
    .highlight {
      height: 3px;
      width: 100%;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      background: #ffffff;
      box-shadow: inset 0 -2px 1px 0 rgba(0, 0, 0, 0.41);
    }

    .p-nav-link {
      display: flex;
      position: relative;
      height: 100%;
      justify-content: center;
      align-items: center;
      padding: 31px 30px 25px 30px;
      a {
        font-family: 'mr-eaves-modern';
        font-weight: 400;
        font-style: normal;
        font-size: 18px;
        color: #fff;
        letter-spacing: 0.5px;
        &:hover {
          &::after {
            content: " ";
            height: 4px;
            width: 50%;
            position: absolute;
            top: 85px;
            left: 25%;
            background-color: $orange;
            transition: all 0.25s ease-in-out;
          }
        }
        &.active {
          &::after {
            content: " ";
            height: 4px;
            width: 50%;
            position: absolute;
            top: 85px;
            left: 25%;
            background-color: $orange;
            transition: all 0.25s ease-in-out;
          }
        }
      }
      button {
        font-family: 'mr-eaves-modern';
        font-weight: 400;
        font-style: normal;
        font-size: 18px;
        color: #fff;
        letter-spacing: 0.5px;
        padding: 0;
        background-color: transparent;
        border: none;
        position: relative;
        bottom: 2px;
        &.active {
          &::after {
            content: " ";
            height: 4px;
            width: 50%;
            position: absolute;
            top: 85px;
            left: 25%;
            background-color: $orange;
            transition: all 0.25s ease-in-out;
          }
        }
        &:focus {
          outline: none;
          box-shadow: none;
        }
      }
    }
  }
}
</style>